import React, { useState } from "react";
import "./compras.css";

import starBlack from "../../assets/img/compras/starBlack.png";
import starWhite from "../../assets/img/compras/starWhite.png";

import Carousel from "../../components/carousel/carousel";

const Compras: React.FC = () => {
  const [selected, setSelected] = useState<"INSTRUMENTOS" | "ACESSÓRIOS">(
    "INSTRUMENTOS"
  );

  return (
    <div className="compras">
      <div>
        <div className="titlePage">
          <img src={starBlack} alt="Imagem de etrela" />
          <p>Compre seu Ripaton</p>
          <img src={starBlack} alt="Imagem de etrela" />
        </div>
        <div className="subMenu">
          <div
            className={
              selected === "INSTRUMENTOS" ? "subMenuContent" : "pointer"
            }
            onClick={() => setSelected("INSTRUMENTOS")}
            style={{ color: selected === "INSTRUMENTOS" ? "#fff" : "#000" }}
          >
            {selected === "INSTRUMENTOS" && (
              <img src={starWhite} alt="estrela" />
            )}
            <p>INSTRUMENTOS</p>
            {selected === "INSTRUMENTOS" && (
              <img src={starWhite} alt="estrela" />
            )}
          </div>

          <div
            className={selected === "ACESSÓRIOS" ? "subMenuContent" : "pointer"}
            onClick={() => setSelected("ACESSÓRIOS")}
            style={{ color: selected === "ACESSÓRIOS" ? "#fff" : "#000" }}
          >
            {selected === "ACESSÓRIOS" && <img src={starWhite} alt="estrela" />}
            <p>ACESSÓRIOS</p>
            {selected === "ACESSÓRIOS" && <img src={starWhite} alt="estrela" />}
          </div>
        </div>
      </div>
      <div>
        <Carousel categoria={selected} />
      </div>
    </div>
  );
};

export default Compras;
